import { useCallback } from 'react';
import { useAsyncFetcher } from 'reporting-data/asyncData/useAsyncFetcher';
import { fetchPropertiesByObjectTypeId } from '../../../api/properties';
export const useFetchProperties = objectTypeId => {
  const fetcher = useCallback(() => fetchPropertiesByObjectTypeId(objectTypeId), [objectTypeId]);
  const asyncProperties = useAsyncFetcher({
    fetcher
  });
  return asyncProperties;
};